import { Project } from '../types';

export const projects: Project[] = [
  {
    id: 'Company Profile Website',
    title: 'Company Profile Website',
    description: 'We create multi-page company profile websites with structured sections to showcase your brand, services, and portfolio. With smooth animations and transitions, the site ensures an engaging and modern user experience. A floating action button adds quick access to key features, enhancing interaction and convenience.',
    image: '/agro.webp',
    url: 'https://sample-company-profile.netlify.app/',
    //category: 'Web Development',
    //technologies: ['React', 'Node.js', 'PostgreSQL', 'Stripe']
  },
  {
    id: 'Financial Platform',
    title: 'Financial Platform',
    description: 'Our Finance App provides real-time insights into market trends, user holdings, and portfolio performance. It enables users to track investments, monitor stock movements, and analyze returns instantly. With an intuitive interface, the app ensures smarter financial decisions anytime, anywhere.',
    image: '/fin.webp',
    url: 'https://sample-site-finance.vercel.app/#portfolio',
    //category: 'Mobile Development',
    //technologies: ['React Native', ']
  },
  {
    id: 'analytics-dashboard',
    title: 'Business Analytics Dashboard',
    description: 'Our Analytical Dashboard provides a comprehensive view of key business metrics with real-time insights and interactive visualizations. It enables tracking of sales, profit, and performance across regions, categories, and segments. Designed for smarter decision-making, it transforms complex data into clear, actionable insights.',
    image: '/AD.webp',
    //category: 'Data Visualization',
    //technologies: ['D3.js', 'Python', 'PostgreSQL', 'Docker']
  },
  {
    id: 'LMS Portal',
    title: 'LMS Portal',
    description: 'Our LMS Portal offers separate access for admins and students, ensuring smooth management and learning. Admins can add courses, manage content, and track enrolled students with ease. Students can purchase courses, complete them at their own pace, and receive verified certificates.',
    image: '/lms.webp',
    url: 'https://demolmsportal.netlify.app/my-courses',
    //category: 'Enterprise Solution',
    //technologies: ['Vue.js', 'Express', 'MongoDB', 'WebRTC']
  },
];